
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { google } from 'google-maps';
import { RenderHelper } from '../services/RenderHelper';
import { MapType } from '../enums/MapType';
import { useMissionsStore } from '../stores/missionsStore';
import RenderColors from '../services/colors';
import { MultiMachinePolygonColors } from '../enums/MultiMachinePolygonColors';
import { PrecisionAgPolygonColors } from '../models/enums/PrecisionAgEnums';

@Component({ name: 'FlightpathPolygon' })
export default class FlightpathPolygon extends Vue {
  @Prop() googleApi!: google;
  @Prop() map!: google.maps.Map<HTMLDivElement>;
  @Prop() polygon!: google.maps.PolygonOptions;
  @Prop() mapType!: MapType;

  mapPolygon = null as google.maps.Polygon | null;
  missionStore = useMissionsStore();

  destroyed() {
    this.mapPolygon?.setMap(null);
  }

  mounted() {
    this.mapPolygon = new this.googleApi.maps.Polygon({
      paths: this.polygon.paths,
      fillColor: this.polygon.fillColor,
      fillOpacity: this.polygon.fillOpacity,
      map: this.map,
      strokeColor: this.polygon.strokeColor,
      strokeOpacity: this.polygon.strokeOpacity,
      visible: this.polygon.visible,
      zIndex: this.polygon.zIndex
    });

    this.updateMapAndArea();
  }

  @Watch('polygon')
  onShapeChange() {
    const newPath = this.polygon.paths?.pop() as Array<google.maps.LatLng>;

    if (this.mapPolygon && newPath) {
      this.mapPolygon.setPath(newPath);
      this.mapPolygon.setOptions({
        fillColor: this.polygon.fillColor,
        fillOpacity: this.polygon.fillOpacity,
        strokeColor: this.polygon.strokeColor,
        strokeOpacity: this.polygon.strokeOpacity,
        visible: true,
        zIndex: this.polygon.zIndex
      });
    }

    this.updateMapAndArea();
  }

  get isSingleMachineFieldBoundary() {
    return this.polygon.strokeColor == RenderColors.Field;
  }

  get isSingleMachineWorkArea() {
    return this.polygon.fillColor == RenderColors.WorkArea;
  }

  get isMultiMachineFieldBoundary() {
    return this.mapType == MapType.MultiMachine && this.polygon.fillColor == MultiMachinePolygonColors.Boundary;
  }

  get isPrecisionAgBoundary() {
    return this.mapType == MapType.PrecisionAg && this.polygon.strokeColor == PrecisionAgPolygonColors.Boundary;
  }

  updateMapAndArea() {
    if (this.isSingleMachineFieldBoundary) {
      this.missionStore.setFieldAreaM2(this.findFieldArea());
    }

    if (this.isSingleMachineWorkArea) {
      this.missionStore.setWorkAreaAreaM2(this.findFieldArea());
    }

    if (this.isMultiMachineFieldBoundary || this.isSingleMachineFieldBoundary || this.isPrecisionAgBoundary) {
      if (this.mapPolygon?.getPath() != undefined && this.mapPolygon.getPath().getLength() != 0) {
        this.map.fitBounds(RenderHelper.getBounds(this.mapPolygon.getPath()));
      }
    }
  }

  findFieldArea() {
    return this.mapPolygon == undefined ? 0 : Math.round(this.googleApi.maps.geometry.spherical.computeArea(this.mapPolygon.getPath()));
  }
}
